import { client, getUrl } from "utils";

export const getInitialScrapeTaskBatchStartsRequest = (filterParams) => client.get(getUrl("initial-scrape-task-batch-starts", filterParams));

export const exportScrapedResultsRequest = ({batch_id, initial_source_code}) => client.get(
    `scrape-task/${batch_id}/result-object/export?storage_type_code=COLD&batch_id=${batch_id}&initial_source_code=${initial_source_code}`,
);

export const runInitialScrapeTaskBatchStartRequest = (data) => client.post("initial-scrape-task/batch-start", data);

export const pidProcessRequest = (pid) => client.get(`process/${pid}`);

export const getDetailedProgressRequest = (id) => client.get(`detailed-progress/${id}`);
